import { useFarcasterContext } from "@hooks/useFarcasterContext";
import { Redirect, router } from "expo-router";
import { useEffect } from "react";

const AccountIndex = () => {
  const { isInMiniApp } = useFarcasterContext();

  useEffect(() => {
    if (isInMiniApp) {
      router.replace("/(app)/(tabs)/profile/you");
    }
  }, [isInMiniApp]);

  return <Redirect href="/(app)/(tabs)/profile/you" />;
};

export default AccountIndex;
